import IconCard from '@/components/common/IconCard/IconCard';
import IconCardList from '@/components/common/IconCard/IconCardList';
import { faBinoculars, faBrowser, faTicket, faUserShield } from '@fortawesome/pro-duotone-svg-icons';
import { Paper, Typography } from '@mui/material';
import { ClientConfigurationContext } from '@ngt/openiddict';
import { FC, useContext } from 'react';

const Administration: FC = () => {
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    return (
        <>
            <Typography variant="h1" gutterBottom>
                Administration
            </Typography>
            <IconCardList>
                <IconCard
                    title="Applications"
                    uri={clientConfiguration?.administrationUris?.applications ?? '/'}
                    icon={faBrowser}
                />
                <IconCard
                    title="Authorizations"
                    uri={clientConfiguration?.administrationUris?.authorizations ?? '/'}
                    icon={faUserShield}
                />
                <IconCard
                    title="Scopes"
                    uri={clientConfiguration?.administrationUris?.scopes ?? '/'}
                    icon={faBinoculars}
                />
                <IconCard
                    title="Tokens"
                    uri={clientConfiguration?.administrationUris?.tokens ?? '/'}
                    icon={faTicket}
                />
            </IconCardList>
        </>
    );
}

export default Administration;